module.exports = __webpack_public_path__ + "static/media/rental-flow-mobile-en.42c3d631.png";